import * as _ from 'lodash-es';
import { createSelector } from 'reselect';

import type { RootState as State } from 'vms/app/rootReducer';

export const selectParts = (state: State) => state.parts.entities;
export const selectEditDialogData = (state: State) => state.parts.editDialogData;
export const selectPartDefinitions = (state: State) => state.parts.definitions;
export const selectIsPartDefinitionsLoadedByTask = (state: State) =>
  state.parts.isDefinitionsLoadedByTask;
export const selectPartDefinitionsByTask = createSelector(selectPartDefinitions, (defs) =>
  _.mapValues(_.groupBy(_.values(defs), 'inspection_task'), (v) => _.keyBy(v, 'id'))
);
